import React from 'react';
import {Button, Icon, Modal, Text} from '@/ui-kits';

interface UploadDocumentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFilesUploaded: (files: File[]) => void;
}

export const UploadDocumentModal: React.FC<UploadDocumentModalProps> = ({
  isOpen,
  onClose,
  onFilesUploaded,
}) => {
  if (!isOpen) return null;

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const filesArray = Array.from(files);
      onFilesUploaded(filesArray);
      onClose();
    }
  };

  return (
    <Modal
      open={isOpen}
      className="rounded-xl xs:w-[320px]  sm:w-[420px] flex flex-col px-4 pb-8">
      <button className="justify-end flex " onClick={onClose}>
        <Icon type="close" className="size-6" />
      </button>

      <div className="flex flex-col px-4 sm:px-12 overflow-hidden">
        <Text variant='subtitle' className="text-ui_blue">
          Please upload documents for one medical condition at a time. You can
          select multiple files together
        </Text>
        <Text variant='small' className="text-ui_input_border_dark justify-center inline-flex gap-1 mt-6 mb-2">
          <p className="text-rejection">*</p>File supported : pdf, jpg, png
        </Text>
        <input
          type="file"
          id="file-upload"
          multiple
          accept=".pdf,.jpg,.jpeg,.png"
          onChange={handleFileSelect}
          className="hidden"
        />
        <div className="flex justify-center w-full">
          <Button
            title="Add Document"
            variant="primary"
            leftIcon="arrow_up_circle_white"
            onClick={() => document.getElementById('file-upload')?.click()}
            className="w-full max-w-full"
            textClassName="xs:text-[12px] sm:text-[14px]"
          />
        </div>
      </div>
    </Modal>
  );
};
